import { EnhancedTabs, TabItem } from 'components/enhanced/tabs/EnhancedTabs';
import { useIsDirector } from 'shared/permissions/useIsDirector';
import { useIsSupplier } from 'shared/permissions/useIsSupplier';
import { useIsTechnician } from 'shared/permissions/useIsTechnician';
import { useIsTechnicianCoordinator } from 'shared/permissions/useIsTechnicianCoordinator';
import { TenantPage } from 'layouts';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import toast from 'shared/utils/toast';
import { ITransportDocument } from '../../types';
import OrderDetailsCard from '../components/card/OrderDetailsCard';
import BaseInfoTab from '../components/tabs/BaseInfoTab';
import MovementsTab from '../components/tabs/MovementsTab';
import { transportDocumentService } from '../api/transport-document.service';

const DOWNLOADABLE_FIELDS = [
  'invoice_file',
  'ddt_file',
  'invoice_revision_file',
  'extra_1_file',
  'extra_2_file',
  'extra_3_file'
];

export function TransportDocumentDetail() {
  const { t } = useTranslation();
  const prefix = 'pages.ddt.detail';
  const { id } = useParams();
  const [ddt, setDdt] = useState<ITransportDocument>();
  const isDisableEdit =
    useIsTechnicianCoordinator() || useIsTechnician() || useIsSupplier() || useIsDirector();

  const getDDTById = () => {
    transportDocumentService.get(+id).then(setDdt);
  };

  useEffect(() => {
    if (!ddt) getDDTById();
  }, []);

  const updateDDT = (values) => {
    delete values['credit_memo_amount'];
    transportDocumentService.update(ddt.id, values).then((res) => {
      setDdt(res);
      toast.success('DDT aggiornato con successo');
    });
  };

  const tabConfig: TabItem[] = ddt
    ? [
        {
          label: t(`global.base-info`),
          component: <BaseInfoTab ddt={ddt} onSubmit={updateDDT} />
        },
        {
          label: t(`${prefix}.order-list`),
          component: <OrderDetailsCard ddt={ddt} />
        },
        {
          label: t(`${prefix}.movement-list`),
          component: <MovementsTab ddt={ddt} getDDTById={getDDTById} />
        }
      ]
    : [];

  return (
    <TenantPage
      title={t(`${prefix}.title`) + ' ' + ddt?.ref}
      subtitle={t(`${prefix}.subtitle`)}
      entityCode={ddt?.ref}>
      <EnhancedTabs
        tabs={tabConfig}
        variant="scrollable"
        documentConfig={{
          serviceName: 'ddt',
          entityId: ddt?.id,
          dictParams: { ddt: id },
          customFolderName: `menu.ddt/'${ddt?.ref}`,
          folderDescription: `Data: ${ddt?.date}; Ordine: ${ddt?.order?.ref}; Fattura: ${ddt?.invoice_ref}; Magazzino: ${ddt?.warehouse}; `,
          disableEdit: isDisableEdit
        }}
        attachmentsConfig={{
          fields: DOWNLOADABLE_FIELDS,
          entity: ddt,
          service: transportDocumentService,
          visible: !isDisableEdit,
          translationPrefix: 'entities.ddt'
        }}
      />
    </TenantPage>
  );
}

export default TransportDocumentDetail;
